import React, { useEffect, useState } from 'react';

type AnimatedBounceProps = {
  children?: React.ReactNode;
  className?: string;
  duration?: string; // e.g. '1.1s'
  delay?: string; // e.g. '0.2s'
  easing?: string; // e.g. 'ease'
  playOnMount?: boolean;
  active?: boolean | undefined;
  style?: React.CSSProperties;
  onAnimationEnd?: React.AnimationEventHandler<HTMLDivElement>;
};

export default function AnimatedBounceRight({
  children,
  className = '',
  duration = '1.1s',
  delay = '0s',
  easing = 'ease',
  playOnMount = true,
  active,
  style,
  onAnimationEnd,
}: AnimatedBounceProps) {
  const [play, setPlay] = useState(false);

  useEffect(() => {
    if (typeof active === 'boolean') {
      setPlay(active);
      return;
    }
    let id: ReturnType<typeof setTimeout> | undefined;
    if (playOnMount) {
      id = setTimeout(() => setPlay(true), 20);
    } else {
      setPlay(false);
    }
    return () => {
      if (id) clearTimeout(id);
    };
  }, [active, playOnMount]);

  const cssVars: React.CSSProperties = {
    ['--anim-bounce-right-duration' as any]: duration,
    ['--anim-bounce-right-delay' as any]: delay,
    ['--anim-bounce-right-ease' as any]: easing,
    ...style,
  };

  return (
    <div
      className={`${className} ${play ? 'anim-bounce-in-right' : 'anim-bounce-hidden'}`}
      style={cssVars}
      onAnimationEnd={onAnimationEnd}
    >
      {children}
    </div>
  );
}
